import { gql } from '@apollo/client';

export const ExtTalentContactFields = gql`
  fragment ExtTalentContactFields on ExtTalentContact {
    extra {
      agentName
    }
    id
    role
    status
    type
    value
  }
`;

export const ExtTalentListContactFields = gql`
  fragment ExtTalentListContactFields on ExtTalentContact {
    extra {
      agentName
    }
    id
    role
    status
    type
    value
  }
`;

export const ExtTalentSocialFields = gql`
  fragment ExtTalentSocialFields on ExtTalentSocial {
    followersCount
    handle
    id
    platform
    profileName
    status
    url
  }
`;

export const ExtTalentListSocialFields = gql`
  fragment ExtTalentListSocialFields on ExtTalentSocial {
    extra {
      avg_engagement
      bio_hashtags_concat
    }
    followersCount
    handle
    id
    platform
    profileName
    status
    url
  }
`;

export const ExtTalentFields = gql`
  fragment ExtTalentFields on ExtTalent {
    athleticLevel
    avatarUrl
    birthDate
    birthMonth
    birthYear
    city
    collegeUniversity
    contacts {
      ...ExtTalentContactFields
    }
    country
    extra {
      college_university_raw
      league_raw
      team_raw
    }
    firstName
    gender
    homeCity
    homeCountry
    homeState
    id
    lastName
    league
    middleName
    socials {
      ...ExtTalentSocialFields
    }
    sport
    state
    status
    team
  }
  ${ExtTalentContactFields}
  ${ExtTalentSocialFields}
`;

export const ExtTalentListFields = gql`
  fragment ExtTalentListFields on ExtTalent {
    athleticLevel
    avatarUrl
    birthDate
    birthMonth
    birthYear
    city
    collegeUniversity
    contacts {
      ...ExtTalentListContactFields
    }
    country
    extra {
      college_university_raw
      league_raw
      team_raw
    }
    firstName
    gender
    homeCity
    homeCountry
    homeState
    id
    lastName
    league
    middleName
    socials {
      ...ExtTalentListSocialFields
    }
    sport
    state
    status
    team
    updatedAt
    userId
  }
  ${ExtTalentListContactFields}
  ${ExtTalentListSocialFields}
`;
